import * as React from 'react';
import { Menu } from '@dropbox/dig-components/menu';
import { Spinner } from '@dropbox/dig-components/progress_indicators';
/**
 * The loading state.
 * This component is not exported.
 */
export const Loading = () => {
    // Wrap the spinner in a div as `Menu.Row` adds many elements
    return (React.createElement(Menu.Row, { interactive: false, preferComposition: true },
        React.createElement("div", { className: "dpc-GlobalHeader-Notification__loading-container" },
            React.createElement(Spinner, null))));
};
Loading.displayName = 'NotificationLoading';
